<template>
  <b-button
    class="float-right"
    size="sm"
    variant="success"
    @click="exportFile()"
  >
    Export
  </b-button>
</template>

<script>
import XLSX from 'xlsx';
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
export default {
  name: 'ProgramReachExport',
  props: {
    json: {
      type: Array,
      required: true,
    },
    headerItems: {
      type: Array,
      required: true,
    }
  },
  computed: {
    ...mapGetters(['fieldsAbs', 'fieldsRel']),
  },
  methods: {
    exportFile() {
      if(this.json.length == 0)
        return;

      const fieldsRelFilteredSorted = this.fieldsRel
        .filter(this.filterOutDateKey)
        .map((e) => ({ ...e, key: `r${e.key}` })); // ES6
      let fields = this.fieldsAbs.concat(fieldsRelFilteredSorted);
      let jsonExport = JSON.parse(JSON.stringify(this.json));
      jsonExport[0].date_key = "Net Reach 1+";
      jsonExport.forEach((element) => {
        delete element.measuresBigScreen;
        delete element.measuresBigScreenRel;
        delete element.measuresDigitalDevices;
        delete element.measuresDigitalDevicesRel;
        delete element.rowNum;
        delete element.title;
        delete element.episode_number;
        delete element.season_number;
        delete element.category_name;
        delete element.contacts;
        delete element.measures;
        delete element.measuresRel;
        delete element.title_key;
        delete element.title_length;
        delete element.date_key_rel;
        //looping through the measures to set measure rel properties last
        for (let i = 0; i < fieldsRelFilteredSorted.length; i++) {
          let createThisPropName = fieldsRelFilteredSorted[i].key;
          let removeThisProp = createThisPropName.substring(1);
          let createThisPropValue = '';
          createThisPropValue = element[removeThisProp];
          delete element[removeThisProp];
          element[createThisPropName] = createThisPropValue;
        }
      });
      let spliceStart = 4;
      jsonExport.splice(spliceStart, 0, ...this.headerItems);
      let ws = XLSX.utils.json_to_sheet(jsonExport);
      let range = XLSX.utils.decode_range(ws['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        let address = XLSX.utils.encode_col(C) + '1';
        if (!ws[address]) continue;
        for (let i = 0; i < fields.length; i++) {
          if (fields[i].key == ws[address].v) {
            ws[address].v = fields[i].label;
            break;
          }
        }
      }
      const csv = XLSX.utils.sheet_to_csv(ws, { FS: ';' });

      const blob = new Blob(['\ufeff', csv]);
      let appName = 'ONLINE VIDEO';
      let date = new Date();
      let dateString = this.dateToString(date);
      let filename = appName + '-' + dateString + '.csv';
      saveAs(blob, filename);
    },
    dateToString(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      return year + '-' + month + '-' + day;
    },
    filterOutDateKey(fieldRel) {
      if (!fieldRel.key.includes('date_key')) return fieldRel;
    },
    round(value, precision) {
      let multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    isDate(date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date));
    },
  },
};
</script>
